export const MailTo = "mailto:hello@copernicaeum.co.uk?subject=I have a great idea"